import { useTranslation } from 'react-i18next';
import type { ReactNode } from 'react';

import {
  DECISION_MODEL_CONFIGS,
  DEFAULT_DECISION_MODEL,
  type AiConsumerTier,
  type AiModel
} from '@bliks-io/contracts';
import { AI_MODEL_LABELS } from '@/pages/admin/ai-model-labels';

function TierLabel({ tier, model }: { tier: AiConsumerTier; model: string }) {
  const { t } = useTranslation();
  return (
    <span className="flex items-baseline gap-1.5">
      <span>{t(`adminSettings.globalAi.featureOverride.tier.${tier}`)}</span>
      <span className="text-muted-foreground text-xs">{model}</span>
    </span>
  );
}

/** The tiers a row can follow. Only a decision-tier row offers Decision: a chat consumer cannot run it. */
export function tierOptions(
  defaultTier: AiConsumerTier,
  highModel: AiModel,
  lowModel: AiModel
): { value: AiConsumerTier; label: ReactNode }[] {
  const chatTiers = [
    { value: 'high' as const, label: <TierLabel tier="high" model={AI_MODEL_LABELS[highModel]} /> },
    { value: 'low' as const, label: <TierLabel tier="low" model={AI_MODEL_LABELS[lowModel]} /> }
  ];
  if (defaultTier !== 'decision') return chatTiers;
  const decisionModel = DECISION_MODEL_CONFIGS[DEFAULT_DECISION_MODEL].label;
  return [
    { value: 'decision', label: <TierLabel tier="decision" model={decisionModel} /> },
    ...chatTiers
  ];
}
